import { getEnv, IStateTreeNode } from "mobx-state-tree";
import { ForeRootStoreEnv } from ".";
import { WsGlobalEventsListener } from "@fidget/common/services/eventsListener";
import { ArtichokeService } from "@fidget/common/services/artichokeService";
import { IForeSpinnerService } from "../services/spinnerService";
import { ForeCallService } from "../services/ForeCallService";

export const servicesGetters = (self: IStateTreeNode) => {
  return {
    get artichokeService(): ArtichokeService {
      return (getEnv(self) as ForeRootStoreEnv).artichokeService;
    },
    get spinnerService(): IForeSpinnerService {
      return (getEnv(self) as ForeRootStoreEnv).spinnerService;
    },
    get eventListener(): WsGlobalEventsListener {
      return (getEnv(self) as ForeRootStoreEnv).eventListener;
    },
    get callService(): ForeCallService {
      return (getEnv(self) as ForeRootStoreEnv).callService;
    }
  };
};
